import { ApplicationRef, ComponentRef, createComponent, EnvironmentInjector, Injectable } from '@angular/core';
import { ImageViewerActions, ImageViewerComponent } from './image-viewer.component';

// Відкриває повноекранний перегляд зображення поверх усього застосунку (веб-CRM і mobile)
@Injectable({ providedIn: 'root' })
export class ImageViewerService {
  private ref: ComponentRef<ImageViewerComponent> | null = null;

  constructor(private appRef: ApplicationRef, private injector: EnvironmentInjector) {}

  open(url: string, actions: ImageViewerActions = {}): void {
    this.close();
    const ref = createComponent(ImageViewerComponent, { environmentInjector: this.injector });
    ref.setInput('url', url);
    ref.setInput('actions', actions);
    ref.instance.closed.subscribe(() => this.close());
    this.appRef.attachView(ref.hostView);
    document.body.appendChild(ref.location.nativeElement);
    this.ref = ref;
  }

  close(): void {
    if (!this.ref) return;
    this.appRef.detachView(this.ref.hostView);
    this.ref.destroy();
    this.ref = null;
  }
}
